import { Component, OnInit } from '@angular/core';
import {getUtcTime} from "../../utils";
import {ActivatedRoute} from "@angular/router";
import {IDynamicRouteData} from "../../routing/dynamic-routing.module";
import {ModalService} from "../../services/modal.service";
import {IStats, ReportsService} from "../../services/reports.service";

@Component({
  selector: 'app-nv-log-stats',
  templateUrl: './nv-log-stats.component.html',
  styles: []
})
export class NvLogStatsComponent implements OnInit {

  apiVersion:number = 0;
  metaVersion:number = 0;
  numDays:number = 3;
  statsData:IStats;


  constructor(private modalService:ModalService,
              private activatedRoute: ActivatedRoute,
              private  reportsService: ReportsService) {

  }

  ngOnInit() {

  }

  onCalculateClick(){
    const data = this.activatedRoute.snapshot.data as IDynamicRouteData;
    this.reportsService.generateReport(data.target, this.numDays, this.apiVersion, this.metaVersion)
      .subscribe((result) => {console.log(result); this.statsData = result});
  }

  getUtcTime(time:number):string
  {
    return getUtcTime(time);
  }

  onUsersClick(event)
  {
    this.modalService.showMessage(event.target.title);
  }

  getUsersList(users:string[])
  {
    return users.join("\n");
  }

}




// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-log-stats/nv-log-stats.component.ts